import { styled } from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`

export const StyledProfileImage = styled.img`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
`

export const StyledUserContainer = styled.div`
  display: flex;
  flex-direction: column;
`
